// extracted by mini-css-extract-plugin
module.exports = {"line":"sanu_line__1Llx1","mobileAppWrapper":"sanu_mobileAppWrapper__1aVWn"};